import styled from "@emotion/styled";

export const ViewSectionRoot = styled.div`
  display: flex;
  align-items: center;
`;
